import React, { useState } from "react";
import { Link } from "react-router-dom";
// import PageBox from "components/PageBox";
import RegisterContent from "components/RegisterContent";
import "./index.less";
import Online from "components/online";


export default function NoticePage() {
	return (
		<div className="register">
			<RegisterContent />
			<div className="register-text">
				<div>版权所有©公共资源数智采平台 </div>
				<div><a href="https://beian.miit.gov.cn/" target="_blank">粤ICP备2022095238号</a></div>
			</div>
			<Online />
		</div>
	);
}
